import * as Models from '../../../models';
import { getAll } from '../get-all';
import { DateHelpers } from '../../../utils';

export interface GetActiveChampionshipsProps {
  mainContentId: Models.OppositionId;
  date: Date;
  includeFromDatetimeStart?: boolean;
  includeFromDatetimeFinish?: boolean;
}

export const getActiveChampionships = (params: GetActiveChampionshipsProps) => {
  const { mainContentId, date, includeFromDatetimeStart, includeFromDatetimeFinish } = params;
  const { datetimeStart, datetimeFinish } = DateHelpers.getDateTimeRange(date);

  return getAll({
    mainContentId,
    datetimeStart: includeFromDatetimeFinish ? undefined : datetimeStart,
    datetimeFinish: includeFromDatetimeStart ? undefined : datetimeFinish,
    orderDatetimeFinish: includeFromDatetimeFinish ? Models.ChampionshipOrderDirection.Desc : undefined,
  });
};
